import { useContext, useEffect } from "react";
import styles from "../../src/assets/sass/arViewer.module.sass";

import ARViewer from "./ARViewer.js";
import useIsMobile from "../utils/useIsMobile.js";
import CurrentContext from "../utils/CurrentContext.js";
import { isAndroid } from "../utils/jsHelper.js";

function ARViewerWrapper() {
  const {
    isARReady,
    setIsARReady,
    setARModelSrc,
    setARUnicode,
    setIsAR,
    doorOpen,
    setLoading,
  } = useContext(CurrentContext);

  const isMobile = useIsMobile();

  const handleClose = () => {
    setARModelSrc(null);
    setIsARReady(false);
    setIsAR(false);
    setLoading(false);
  };

  useEffect(() => {
    return () => handleClose();
  }, []);

  if (!isARReady || (isMobile && !isAndroid())) return null;

  return (
    <div className={styles.ar_wrapper}>
      <div className={styles.ar_model_container}>
        <button className={styles.close} onClick={handleClose}>
          X
        </button>
        <ARViewer />
      </div>
    </div>
  );
}

export default ARViewerWrapper;
